<template>
  <VDialogV3
    id="supply-offer-tariff-card"
    width="400px"
    :entity="localTariff"
    :loading="false"
    @submit="submit"
  >
    <section>
      <VInputNumberRus
        v-model="localTariff.qty.start"
        label="Кол-во, от"
        :unit="supplyOffer.unit"
        required
      />

      <VInputNumberRusV2
        v-model="localTariff.price"
        label="Цена"
        helper-text-position="right"
        :type="Price"
        :unit="`${supplyOffer?.unit} / ${supplyOffer?.currency?.toString({ format: 'symbol' })}`"
        required
      />

      <VDateInput
        v-model="localTariff.actualFor.start"
        label="Дата"
        layout="vertical"
        placeholder="Дата"
        required
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">
import SupplyOffer       from '@/domains/SupplyOffers/SupplyOffer';
import SupplyOfferTariff from '@/domains/SupplyOffers/SupplyOfferTariff';
import Price             from '@/core/types/Price';

export default defineComponent({
  name: 'SupplyOfferTariffCard',

  props: {
    /** Родительское разрешение — нужно для валюты и единицы измерения */
    supplyOffer: {
      type:     Object as PropType<SupplyOffer>,
      required: true,
    },

    /** Тариф для редактирования. null — режим создания */
    tariff: {
      type:    Object as PropType<SupplyOfferTariff>,
      default: null,
    },
  },

  emits: [SupplyOffer.Events.Updated],

  setup() {
    return {
      Price,
    };
  },

  data() {
    let localTariff;

    if (this.tariff) {
      localTariff = this.$core.utils.cloneDeep(this.tariff);
    }
    else {
      localTariff = SupplyOfferTariff.getEmpty(this.supplyOffer);
    }

    return {
      localTariff,
    };
  },

  methods: {
    submit(): void {
      this.$emit(SupplyOffer.Events.Updated, this.localTariff);
      this.$core.dialogs.SupplyOfferTariffCard.resolve();
    },
  },
});
</script>
